import { AHIcon, Circle, TouchableBox, useLayoutContext } from "arkh";
import React from "react";

import { useSafeAreaInsets } from "react-native-safe-area-context";

export const FloatingAddButton = (props: {
  onPress: () => void;
  testID?: string;
}) => {
  const layout = useLayoutContext();
  const insets = useSafeAreaInsets();

  return (
    <TouchableBox
      testID={props.testID}
      onPress={props.onPress}
      style={{
        position: "absolute",
        bottom: layout.space.medium + insets.bottom,
        right: layout.space.medium,
      }}
    >
      <Circle size="large" color="primary">
        <AHIcon type="add" color="text-inverted" forceSize={20} />
      </Circle>
    </TouchableBox>
  );
};
